<template>
    <div id="app">
        <loading></loading>
        <modal></modal>
        <confirm></confirm>
        <router-view/>
    </div>
</template>
<script>

export default {
  name: 'App'
}
</script>

<style>
    html, body {
        height: 100%;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: left;
        color: #2c3e50;
    }

    .container-login {
      margin-top: 30px
    }

    th.table-button-column {
        width: 1px;
    }

    .table td, .table th {
      vertical-align: middle;
    }

    .is-full-width {
        width: 100%
    }

    nav.breadcrumb {
        font-size: 1.6em;
        /*font-weight: bold;*/
    }

    li.is-active {
        font-weight: bold;
    }

    .button.is-primary, .file.is-primary .file-cta {
        background-color: #388ab3;
        border-color: transparent;
        color: whitesmoke;
    }

    .button.is-primary:hover, .button.is-primary:active, .button.is-primary.is-hovered, .button.is-primary[disabled], .file.is-primary:hover .file-cta, .file.is-primary.is-hovered .file-cta {
        background-color: #296482;
        border-color: transparent;
        color: #fff;
    }

    .button.is-warning, .file.is-warning .file-cta {
        background-color: #1b4454;
        border-color: transparent;
        color: whitesmoke;
    }

    .button.is-warning:hover, .button.is-warning:active, .button.is-warning.is-hovered, .button.is-warning[disabled], .file.is-warning:hover .file-cta, .file.is-warning.is-hovered .file-cta {
        background-color: #2e708a;
        border-color: transparent;
        color: whitesmoke;
    }

    .button.is-info, .file.is-info .file-cta {
        background-color: #246d84;
        border-color: transparent;
        color: whitesmoke;
    }

    .button.is-info:hover, .button.is-info:active, .button.is-info.is-hovered, .button.is-info[disabled], .file.is-info:hover .file-cta, .file.is-info.is-hovered .file-cta {
        background-color: #1b5061;
        border-color: transparent;
        color: whitesmoke;
    }

    .button.is-danger, .file.is-danger .file-cta {
        background-color: #b93b3b;
        border-color: transparent;
        color: whitesmoke;
    }

    .button.is-danger:hover, .button.is-danger:active, .button.is-danger.is-hovered, .button.is-danger[disabled], .file.is-hovered:hover .file-cta, .file.is-hovered.is-hovered .file-cta {
        background-color: #822929;
        border-color: transparent;
        color: whitesmoke;
    }

    .tabs.is-toggle li.is-active a {
        background-color: #388ab3;
        border-color: transparent;
        color: whitesmoke;
    }

    .tabs.is-boxed.is-fullwidth li {
        width: 33%;
    }

    .pagination-link.is-current {
      background-color: #4095bc;
      border-color: transparent;
      color: whitesmoke;
    }

    .field.has-addons.no-margin {
      margin-top: 0;
      margin-bottom: 0;
    }

    .field.has-addons .control {
      width: 50px;
      margin: 0;
    }

    .field.has-addons .control .button {
      width: 100%;
    }

    .card-404 {
      margin-top: 100px;
    }
    .h1-404 {
      font-size: 8rem;
    }

    .is-flex-one-line-container {
      align-items: flex-end
    }

    .no-margin-bottom {
      margin-bottom: 0 !important;
    }

    .padding-left-10 {
      padding-left: 10px !important;
    }

    .navbar-item-new {
      color: whitesmoke !important;
    }

    .navbar-item-new:hover {
      background-color: #292929 !important;
      color: whitesmoke !important;
    }

    .emoji-container {
       display: flex;
       flex-direction: row;
       flex-wrap: wrap;
     }

    .emoji-fixed-width {
      width: 58px
    }

    .input_error {
      border: 1px solid red;
    }

    .is-rate {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }

    .is-rate span {
      padding-left: 5px;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue